module.exports = __webpack_public_path__ + "img/right-nav-three.1e3e79c3.png";